import axios from "@/plugins/axios";

import body from "./body";
import head from "./head";

let url = "/api/console/mes/reports";

export const reports = {
    body,
    head,

    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data.process}/${data.planDate}`, data).then((result) => result.data);
    },
};

export default reports;
